/**
 * Future seller submission → draft listing mapping (Sell Your Car M2).
 * Does not publish or persist listings — admin approval required in later milestones.
 */

function pickNullableString(value) {
  if (value == null) return null;
  const text = String(value).trim();
  return text || null;
}

function buildDescriptionDraft(record) {
  const parts = [];
  if (record.conditionSummary) parts.push(record.conditionSummary);
  if (record.notes) parts.push(record.notes);
  return parts.length ? parts.join("\n\n") : null;
}

/**
 * Maps a stored seller submission record to a draft listing shape for admin conversion.
 * @param {import('./sellerIntakeTypes').SellerSubmissionRecord|object} record
 * @returns {import('./sellerIntakeTypes').SellerDraftListingMapping}
 */
export function mapSellerSubmissionRecordToDraftListing(record = {}) {
  return {
    make: pickNullableString(record.vehicleMake),
    model: pickNullableString(record.vehicleModel),
    year: record.vehicleYear ?? null,
    trim: pickNullableString(record.vehicleTrim),
    mileageKm: record.vehicleMileageKm ?? null,
    price: record.askingPrice ?? null,
    currency: record.currency || "COP",
    city: pickNullableString(record.city),
    department: pickNullableString(record.department),
    descriptionDraft: buildDescriptionDraft(record),
    sourceSubmissionId: record.id ? String(record.id) : null,
    ownershipStatus: record.ownershipStatus || null,
  };
}

/**
 * Field-level mapping reference for documentation and admin tooling.
 * Keys are SellerSubmissionRecord fields; values are draft listing field names.
 */
export const SELLER_TO_LISTING_FIELD_MAP = Object.freeze({
  vehicleMake: "make",
  vehicleModel: "model",
  vehicleYear: "year",
  vehicleTrim: "trim",
  vehicleMileageKm: "mileageKm",
  askingPrice: "price",
  currency: "currency",
  city: "city",
  department: "department",
  conditionSummary: "descriptionDraft (partial)",
  notes: "descriptionDraft (partial)",
  id: "sourceSubmissionId",
});
